// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "06325b31dcaa8a4cebfec4b30cb961b2" + ".js";
};